/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateNaceDivisionDto } from '../models';
// @ts-ignore
import type { CreateNaceSectionDto } from '../models';
// @ts-ignore
import type { NaceDivisionBasicDto } from '../models';
// @ts-ignore
import type { NaceSectionBasicDto } from '../models';
/**
 * NACEApi - axios parameter creator
 * @export
 */
export const NACEApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<CreateNaceDivisionDto>} createNaceDivisionDto Array of nace divisions to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerCreateNaceDivision: async (createNaceDivisionDto: Array<CreateNaceDivisionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNaceDivisionDto' is not null or undefined
            assertParamExists('naceControllerCreateNaceDivision', 'createNaceDivisionDto', createNaceDivisionDto)
            const localVarPath = `/api/nace/divisions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNaceDivisionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateNaceSectionDto>} createNaceSectionDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerCreateNaceSection: async (createNaceSectionDto: Array<CreateNaceSectionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNaceSectionDto' is not null or undefined
            assertParamExists('naceControllerCreateNaceSection', 'createNaceSectionDto', createNaceSectionDto)
            const localVarPath = `/api/nace/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNaceSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceDivisions: async (sectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('naceControllerGetNaceDivisions', 'sectionId', sectionId)
            const localVarPath = `/api/nace/divisions/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceSections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nace/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NACEApi - functional programming interface
 * @export
 */
export const NACEApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NACEApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<CreateNaceDivisionDto>} createNaceDivisionDto Array of nace divisions to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async naceControllerCreateNaceDivision(createNaceDivisionDto: Array<CreateNaceDivisionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.naceControllerCreateNaceDivision(createNaceDivisionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NACEApi.naceControllerCreateNaceDivision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateNaceSectionDto>} createNaceSectionDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async naceControllerCreateNaceSection(createNaceSectionDto: Array<CreateNaceSectionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.naceControllerCreateNaceSection(createNaceSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NACEApi.naceControllerCreateNaceSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async naceControllerGetNaceDivisions(sectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NaceDivisionBasicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.naceControllerGetNaceDivisions(sectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NACEApi.naceControllerGetNaceDivisions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async naceControllerGetNaceList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NaceSectionBasicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.naceControllerGetNaceList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NACEApi.naceControllerGetNaceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async naceControllerGetNaceSections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NaceSectionBasicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.naceControllerGetNaceSections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NACEApi.naceControllerGetNaceSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NACEApi - factory interface
 * @export
 */
export const NACEApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NACEApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<CreateNaceDivisionDto>} createNaceDivisionDto Array of nace divisions to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerCreateNaceDivision(createNaceDivisionDto: Array<CreateNaceDivisionDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.naceControllerCreateNaceDivision(createNaceDivisionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<CreateNaceSectionDto>} createNaceSectionDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerCreateNaceSection(createNaceSectionDto: Array<CreateNaceSectionDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.naceControllerCreateNaceSection(createNaceSectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceDivisions(sectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NaceDivisionBasicDto>> {
            return localVarFp.naceControllerGetNaceDivisions(sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceList(options?: RawAxiosRequestConfig): AxiosPromise<Array<NaceSectionBasicDto>> {
            return localVarFp.naceControllerGetNaceList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        naceControllerGetNaceSections(options?: RawAxiosRequestConfig): AxiosPromise<Array<NaceSectionBasicDto>> {
            return localVarFp.naceControllerGetNaceSections(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NACEApi - object-oriented interface
 * @export
 * @class NACEApi
 * @extends {BaseAPI}
 */
export class NACEApi extends BaseAPI {
    /**
     * 
     * @param {Array<CreateNaceDivisionDto>} createNaceDivisionDto Array of nace divisions to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NACEApi
     */
    public naceControllerCreateNaceDivision(createNaceDivisionDto: Array<CreateNaceDivisionDto>, options?: RawAxiosRequestConfig) {
        return NACEApiFp(this.configuration).naceControllerCreateNaceDivision(createNaceDivisionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<CreateNaceSectionDto>} createNaceSectionDto Array of nace sections to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NACEApi
     */
    public naceControllerCreateNaceSection(createNaceSectionDto: Array<CreateNaceSectionDto>, options?: RawAxiosRequestConfig) {
        return NACEApiFp(this.configuration).naceControllerCreateNaceSection(createNaceSectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NACEApi
     */
    public naceControllerGetNaceDivisions(sectionId: string, options?: RawAxiosRequestConfig) {
        return NACEApiFp(this.configuration).naceControllerGetNaceDivisions(sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NACEApi
     */
    public naceControllerGetNaceList(options?: RawAxiosRequestConfig) {
        return NACEApiFp(this.configuration).naceControllerGetNaceList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NACEApi
     */
    public naceControllerGetNaceSections(options?: RawAxiosRequestConfig) {
        return NACEApiFp(this.configuration).naceControllerGetNaceSections(options).then((request) => request(this.axios, this.basePath));
    }
}

